import React, { useState } from 'react';
import {
    deepCopy,
    createTimeStamp
} from '../../../store/quotesAndNotificationsSlice';
import Input from '../../../components/Input/Input';
import Accordion from '../../../components/Accordion/Accordion';
import {
    setUserTypeLoadingStatus
} from '../../../store/delegationOfAuthoritySlice';
import { useDispatch, useSelector } from 'react-redux';
import './ViewUserType.css';

function ViewUserType(props){

    const [ editUserType, setEditUserType ] = useState( props.isCreateUserType );
    const [ userType, setUserType ] = useState( deepCopy( props.userType ) );
    const [ addedRoles, setAddedRoles ] = useState([]);
    const [ newRole, setNewRole ] = useState('');
    const dispatch = useDispatch();

    function cancelUserTypeEdit(){
        setEditUserType(false);
        setUserType( deepCopy(props.userType) );
        if( props.isCreateUserType ){
            props.cancelCreate();
        }
    }

    function handleUserTypeName(e){
        let _userType = deepCopy(userType);
        _userType.userType = e.target.value;
        setUserType(_userType);
    }

    function saveChanges(){
        //dispatch( setUserTypeLoadingStatus('loading') );
        const newUserType = deepCopy(userType);
        if( newUserType.userType.trim() !== '' ){
            const newRoleObjects = addedRoles.map( addedRole => {
                return {
                    "role": addedRole,
                    "users": [
                        {
                            "timestamp": createTimeStamp(),
                            "activeUsers": []
                        }
                    ],
                };
            });
            if ( newRoleObjects.length > 0 ){
                newUserType.userRoles = [ ...newUserType.userRoles, ...newRoleObjects ];
            }
            if( newUserType.userRoles.length === 0 ){
                newUserType.userRoles.push(
                    {
                        "role": newUserType.userType,
                        "users": [
                            {
                                "timestamp": createTimeStamp(),
                                "activeUsers": []
                            }
                        ],
                    }
                );
            }
            //console.log(JSON.stringify(newUserType));
            props.saveUserType(newUserType).unwrap().then(res =>{
                if( res === true ){
                    props.updateUserTypes(newUserType, props.isCreateUserType);
                    setEditUserType(false);
                    setNewRole('');
                    setAddedRoles([]);
                    props.cancelCreate?.();
                    // props.getUserTypes().unwrap().then(res =>{
                        // setEditUserType(false);
                        // setNewRole('');
                        // setAddedRoles([]);
                        // props.cancelCreate?.();
                    // });
                }
            }).catch( error => console.log(error) );
        }
    }

    function addOrRemoveRole(action, role){
        let userTypeObj = deepCopy( userType );
        let newAddedRoles;
        let roleExists = false;
        if( action === 'add' ){
            userTypeObj.roles.forEach( r => {
                if ( r.toLowerCase() === newRole.trim().toLowerCase() ){
                    roleExists = true;
                }
            });
            if ( !roleExists ){
                newAddedRoles = [ ...addedRoles, newRole.trim() ];
                userTypeObj.roles = [ ...userTypeObj.roles, newRole.trim() ];
            } else {
                newAddedRoles = addedRoles;
            }
            setNewRole('');
        } else {
            newAddedRoles = addedRoles.filter( r => r !== role );
            userTypeObj.roles = userTypeObj.roles.filter( r => r !== role );
        }
        setAddedRoles( newAddedRoles );
        setUserType( userTypeObj );
    }

    function addOrRemovePermission(e){
        let permission = e.target.getAttribute('name');
        let userTypeObj = deepCopy(userType);
        if ( e.target.checked ){
            userTypeObj.permissions = [...userType.permissions, permission];
        } else {
            userTypeObj.permissions = userType.permissions.filter(p => p !== permission);
        }
        setUserType( userTypeObj );
    }

    let permissions = [];

    const roles = userType.roles.map(role => {
        return (
            <li className="view_user_type_permission_li" key={role}>
                { role }
                {
                    addedRoles.includes(role) &&
                    <button 
                        className="remove_role_button"
                        onClick={ () => addOrRemoveRole('remove', role) }
                    >
                        <svg fill="#fff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="12px" height="12px" >
                            <path d="M 4.9902344 3.9902344 A 1.0001 1.0001 0 0 0 4.2929688 5.7070312 L 10.585938 12 L 4.2929688 18.292969 A 1.0001 1.0001 0 1 0 5.7070312 19.707031 L 12 13.414062 L 18.292969 19.707031 A 1.0001 1.0001 0 1 0 19.707031 18.292969 L 13.414062 12 L 19.707031 5.7070312 A 1.0001 1.0001 0 0 0 18.980469 3.9902344 A 1.0001 1.0001 0 0 0 18.292969 4.2929688 L 12 10.585938 L 5.7070312 4.2929688 A 1.0001 1.0001 0 0 0 4.9902344 3.9902344 z" stroke="#fff" strokeWidth="2" />
                        </svg>
                    </button>
                }
            </li>
        );
    });

    const users = [];
    if( !props.isCreateUserType ){
        userType.userRoles.forEach(userRole => {
            userRole.users[0].activeUsers.forEach(user => { 
                users.push(
                    <li className="view_user_type_permission_li" key={user.userId}>
                        { user.userName }
                    </li>
                );
            });
        });
        if( users.length === 0 ){
            users.push(
                <li className="view_user_type_permission_li" key={"none"}>
                    None
                </li>
            );
        }
    } else {
        users.push(
            <li className="view_user_type_permission_li" key={"none"}>
                None
            </li>
        );
    }

    if( editUserType ){
        permissions = props.permissionsArray.map( (permission, i) =>{
            let checked = userType.permissions.includes(permission);
            //let permissionLabel = permission.split('.')[1];
            let permissionLabel = permission;
            return (
                <li className="create_user_type_permission_li" key={i}>
                    <Input
                        type="checkbox"
                        handleChange={ addOrRemovePermission }
                        label={ permissionLabel }
                        name={ permissionLabel }
                        checked={ checked }
                    />
                </li>
            );
        });
        roles.push(
            <li className="new_role_li" key={"new_role_add"}>
                <Input 
                    type="text"
                    handleChange={ (e) => setNewRole(e.target.value) }
                    placeHolder="New role"
                    inputClass="new_role_input"
                    value={ newRole }
                />
                <button className="new_role_button" onClick={ () => addOrRemoveRole('add') }>+</button>
            </li>
        )
    } else {
        permissions = userType.permissions.map(permission =>{
            //let permissionLabel = permission.split('.')[1];
            let permissionLabel = permission;
            return (
                <li className="view_user_type_permission_li" key={permission}>
                    { permissionLabel }
                </li>
            );
        });
        if( permissions.length === 0 ){
            permissions.push(
                <li className="view_user_type_permission_li" key={"none"}>
                    None
                </li>
            );
        }
    }
    
    return (

        <Accordion
            headContent={
                <div className="user_type_title_container">
                    <h3 className="user_type_title">
                        { userType.userType || <>&nbsp;</> }
                    </h3>
                </div>
            }
            controlled={ props.isCreateUserType }
            isOpen={ props.isCreateUserType }
        >
            <div className="view_user_type_content">
                <div className="view_user_type_action_button_container">
                    { 
                        editUserType && props.adminUserRole === 'Super Admin' &&
                        <>
                            {
                                props.isCreateUserType &&
                                <div className="user_type_input_container">
                                    <Input 
                                        type="text"
                                        placeHolder="User Type"
                                        handleChange={ handleUserTypeName }
                                        value={ userType.userType || '' }
                                    />
                                </div>
                            }
                            <button className="user_type_edit_button cancel_user_type_edit" onClick={ cancelUserTypeEdit } >Cancel</button>
                            <button className="user_type_edit_button save_user_type_edit" onClick={ saveChanges } >Save Changes</button>
                        </>
                    }
                    {
                        !editUserType && props.adminUserRole === 'Super Admin' && 
                        <button className="user_type_edit_button edit_user_type" onClick={ () => setEditUserType(true) }>Edit</button>
                    }
                </div>
                <div className="view_user_type_lists">
                    <ul className="view_user_type_permission_ul">
                        <li className="view_user_type_list_header">Permissions</li>
                        { permissions }
                    </ul>
                    <ul className="view_user_type_permission_ul">
                        <li className="view_user_type_list_header">Roles</li>
                        { roles }
                    </ul>
                    
                    <ul className="view_user_type_permission_ul">
                        <li className="view_user_type_list_header">Users</li>
                        { users }
                    </ul>
                </div>
            </div>
        </Accordion>
    );
}

export default ViewUserType;